import { useContext, useState, useEffect } from "react";
import { UserContext } from "../context/UserProvider";
import Swal from 'sweetalert2';
import { Navigate } from "react-router-dom";
import { Api } from "../componentes/Api";
import { Card, Col, Row, CardBody, CardHeader, Button, Modal, ModalHeader, ModalBody, Label, Input, FormGroup, ModalFooter } from "reactstrap";
import validator from 'validator';
import React, { useRef } from 'react';
import emailjs from '@emailjs/browser';


const modeloUsuario = {
    idUsuario: 0,
    empresaID: 0,
    nombre: "",
    correo: "",
    telefono: "",
    idRol: 4,
    clave: "",
    dgii: "",

    esActivo: true
}
const Login = () => {

    const [_correo, set_Correo] = useState("")
    const [_clave, set_Clave] = useState("")
    const { user, iniciarSession } = useContext(UserContext)
    const [usuario, setUsuario] = useState(modeloUsuario);

    const [roles, setRoles] = useState([]);
    const [verModal, setVerModal] = useState(false);
    const [Reg, setReg] = useState(true);
    const [ListaEmpr, SetListaEmpr] = useState([]);
    const [emailError, setEmailError] = useState('');

 

    const form = useRef();

    const sendEmail = (e) => {
        e.preventDefault();

        emailjs.sendForm('service_0hli5un', 'template_ixkbi04', form.current, 'lQQs5pUGa38VFF5KU')
            .then((result) => {
                console.log(result.text);
            }, (error) => {
                console.log(error.text);
            });
    };




    if (user != null) {
        return <Navigate to="/"/>
    }

    const handleSubmit = (event) => {
        event.preventDefault();

        let request = {
            correo: _correo,
            clave:_clave
        }

        const api = fetch(Api+"session/Login", {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json;charset=utf-8'
            },
            body: JSON.stringify(request)
        })
            .then((response) => {

            return response.ok ? response.json() : Promise.reject(response);
        })
        .then((dataJson) => {
            if (dataJson.idUsuario == 0) {
                Swal.fire(
                    'Opps!',
                    'No se encontro el usuario',
                    'error'
                )
            } else {
                dataJson.clave = dataJson.dgii;
                iniciarSession(dataJson)
            }

        }).catch((error) => {
            Swal.fire(
                'Opps!',
                'No se pudo iniciar sessión',
                'error'
            )
        })
    }

    //const handleSubmit = async (event) => {
    //    event.preventDefault();

    //    const request = {
    //        correo: _correo,
    //        clave: _clave,
    //    };

    //    try {
    //        // Api debe terminar en /api/ por ejemplo:
    //        // const Api = "http://localhost/api/";
    //      //  const url = `${Api}session.php?action=login`;
    //        const url = `http://localhost/api/session.php?action=login`;

    //        const response = await fetch(url, {
    //            method: "POST",
    //            headers: {
    //                "Content-Type": "application/json;charset=utf-8",
    //            },
    //            body: JSON.stringify(request),
    //        });

    //        if (!response.ok) {
    //            throw new Error(`HTTP ${response.status}`);
    //        }

    //        const dataJson = await response.json();

    //        // Si el PHP devuelve [] cuando no encuentra usuario:
    //        // dataJson será [] (array) o null/{} según tu backend.
    //        const idUsuario = dataJson?.idUsuario ?? dataJson?.IdUsuario; // por si viene con mayúsculas

    //        if (!idUsuario) {
    //            Swal.fire("Opps!", "No se encontró el usuario", "error");
    //            return;
    //        }

    //        // Si quieres guardar sessionid
    //        const sessionId = dataJson?.sessionid ?? dataJson?.SessionId;
    //        if (sessionId) {
    //            localStorage.setItem("sessionid", sessionId);
    //        }

    //        // (Opcional) Guardar usuario completo
    //        localStorage.setItem("usuario", JSON.stringify(dataJson));

    //        // OJO: esto se ve raro, lo dejo porque estaba en tu código
    //        // dataJson.clave = dataJson.dgii;

    //        iniciarSession(dataJson);
    //    } catch (error) {
    //        console.error(error);
    //        Swal.fire("Opps!", "No se pudo iniciar sesión", "error");
    //    }
    //};

    const handleChange = (e) => {

        console.log(e.target.value)

        let value;

        if (e.target.name == "idRol") {
            value = e.target.value
        } else if (e.target.name == "esActivo") {
            value = (e.target.value == "true" ? true : false)
        } else {
            value = e.target.value;
        }

        if (e.target.name == "correo" && validator.isEmail(value)) {
            setEmailError('')

            ValidarCorreo(value);


            setReg(false);
        } else {
            if (e.target.name == "correo") {
                setEmailError('Entre un email valido!');
            setReg(true);
        }
        }
        setUsuario({
            ...usuario,
            [e.target.name]: value
        })
    }

    const ValidarCorreo = async (x) => {
        let response1 = await fetch(Api + "Usuario/ValidarUsuario" + "/" + x);
        if (response1.ok) {
            let data1 = await response1.json()
            Swal.fire(
                'Opps!',
                'El correo que registrar existe. Intente con otra cuenta',
                'error'
            )

        }
    }

    const guardarCambios = async () => {

        delete usuario.idRolNavigation;
        usuario.empresaID = parseInt(usuario.empresaID);
        let response;
        if (usuario.idUsuario == 0 && usuario.clave != "" && usuario.nombre != "") {
            response = await fetch(Api + "usuario/GuardarRegistro", {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(usuario)
            })

        } else {
            response = await fetch(Api + "", {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(usuario)
            })
        }

        if (response.ok) {
           
            Swal.fire(
                'Cuenta Creada, Ya puedes iniciar!',
                'Las credenciales de su cuenta fueron enviada al correo '+ usuario.correo,
                'success'
            )
            setVerModal(!verModal);

        } else {
            alert("Faltan Campos por llenar.")
        }

       
    }

    return (
        <div className="container">

            


            <div className="row justify-content-center">

                <div className="col-xl-10 col-lg-12 col-md-9">

                    <div className="card o-hidden border-0 shadow-lg my-5">
                        <div className="card-body p-0">

                            <div className="row">
                                <div className="col-lg-6 d-none d-lg-block bg-login-image">
                                    <img class="card-img-top" src="./imagen/LogoApatech.png" style={{ width: '80%', height: '86%' }} />
                                </div>
                                <div className="col-lg-5">
                                    <div className="p-5">
                                        <div className="text-center">
                                            <h1> APATECH TOOLS</h1> 
                                            <h1 className="h4 text-gray-900 mb-4" style={{backgroundColor:"#fff"} }>Bienvenido</h1>
                                        </div>
                                        <form className="user" onSubmit={handleSubmit}>
                                            <div className="form-group">
                                                <input type="text" className="form-control form-control-user"  placeholder="Usuario"
                                                    value={_correo}
                                                    onChange={(e) => set_Correo(e.target.value)}
                                                />
                                            </div>
                                            <div className="form-group">
                                                <input type="password" className="form-control form-control-user" placeholder="Contraseña"
                                                    value={_clave}
                                                    onChange={(e) => set_Clave(e.target.value)}
                                                />
                                            </div>
                                            <button type="submit" className="btn btn-primary btn-user btn-block"> Ingresar </button>
                                            
                                        </form>
                                        <hr></hr>
                                        <a class="btn" color="success" size="sm" onClick={() => setVerModal(true)}>Registrarse </a>


                                    </div>
                                </div>
                            </div>
                        </div>
                </div>

                </div>

            </div>

            <Modal isOpen={verModal}>
                <ModalHeader className=" modal-header1">
                   Creación de nueva cuenta
                </ModalHeader>
                <form ref={form} onSubmit={sendEmail}>
                    <ModalBody>
                   
                    <Row>
                        <Col sm={6}>
                            <FormGroup>
                                <span style={{ color: 'red', }}>*</span>     <Label>Nombre</Label>
                                <Input bsSize="sm" name="nombre" onChange={handleChange} value={usuario.nombre} />
                            </FormGroup>
                        </Col>
                        <Col sm={6}>
                            <FormGroup>
                                <span style={{ color: 'red', }}>*</span>
                                <Label>Correo</Label>

                                <Input bsSize="sm"  name="correo" onChange={handleChange} value={usuario.correo} />
                            
                                <span style={{
                                    fontWeight: 'bold',
                                    color: 'red',
                                }}>{emailError}</span>
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={6}>
                            <FormGroup>
                                 <Label>Telefono</Label>
                                <Input bsSize="sm" type="number" name="telefono" onChange={handleChange} value={usuario.telefono} />
                            </FormGroup>
                        </Col>
                 
                        <Col sm="6" >
                            <FormGroup>
                                <span style={{ color: 'red', }}>*</span>  <Label>Contraseña</Label>
                                <Input bsSize="sm" name="clave" onChange={handleChange} value={usuario.clave} type="password" />
                            </FormGroup>
                        </Col>

                       
                        {/*<Col sm="4" >*/}
                        {/*    <FormGroup>*/}
                        {/*        <Label>Estado</Label>*/}
                        {/*        <Input bsSize="sm" type={"select"} name="esActivo" onChange={handleChange} value={usuario.esActivo} >*/}
                        {/*            <option value={true}>Activo</option>*/}
                        {/*            <option value={false}>No Activo</option>*/}
                        {/*        </Input>*/}
                        {/*    </FormGroup>*/}
                        {/*</Col>*/}
                    </Row>
                    <p class="terminos">La creacion de esta cuenta solo tendra acceso al modulo de registro de NCF.</p>
                       
                </ModalBody>
                <ModalFooter>
                        <Button hidden={Reg} type="submit" value="Send"  size="sm" color="primary" onClick={guardarCambios}>Registrarme</Button>
                    <Button size="sm" class="btn "onClick={()=>setVerModal(false)}>Cancelar</Button>
                </ModalFooter> </form>
            </Modal>

        </div>

        )
}

export default Login